import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './styles/logitrack-design-system.css';
import './styles/premium-theme.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
